export default "__VITE_ASSET__DkzKljYV__"